import React from 'react';
import BCrumb from 'Components/Bcrumb/BCrumb.jsx';
import Layout from 'Components/layout/Layout.jsx';
import Survey from 'Components/survey/Survey.jsx';

const PlayGround = () => (
    <Layout>
        <BCrumb />
        <Survey />
    </Layout>
);

export default PlayGround;
